module.exports = {
    RELEASE: 'undefined'
};



// WEBPACK FOOTER //
// ./frontend/src/js/debug/sentry-release.js